import { render, staticRenderFns } from "./_leaveRecord.vue?vue&type=template&id=4cd6c489&scoped=true"
import script from "./_leaveRecord.vue?vue&type=script&lang=js"
export * from "./_leaveRecord.vue?vue&type=script&lang=js"
import style0 from "./_leaveRecord.vue?vue&type=style&index=0&id=4cd6c489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd6c489",
  null
  
)

export default component.exports